/*** Variant Stock Logic for whole site ***/
function variantStockLogic(variant, cb) {
  if (variant) {
    var isIdkVariant = false
    var isOMSLeadTimeMadeToOrder = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-made-to-order')) : [];
    var isOMSLeadTimeInStock = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-in-stock')) : [];
    if (variant.option1 && variant.option1.indexOf("I don't know my size;") !== -1) {
      isIdkVariant = true
    }
    if (variant.option2 && variant.option2.indexOf("I don't know my size;") !== -1) {
      isIdkVariant = true
    }
    if (variant.option3 && variant.option3.indexOf("I don't know my size,") !== -1) {
      isIdkVariant = true
    }
    if (!isIdkVariant && isOMSLeadTimeMadeToOrder.length === 0 && isOMSLeadTimeInStock.length === 0) {
      var dropdownMessage = ""
      var trackQuantity = variant.inventory_management
      // If Track quantity is null means checked(:OFF) means users can but it anytime
      if (trackQuantity === null) {
        if (variant.availableToSell <= 0 && variant.customLeadTime) {
          cb(null, { showPopup: true, isVariantLeadMessage: true, dropdownMessage: "Made to Order", ...variant })
        }
        else {
          cb(null, { showPopup: true, isVariantLeadMessage: true, dropdownMessage: "Made to Order", ...variant })
        }
      }
      // Else is automatically representing that inventory_policy is set to deny
      else {
        /* Show In stock if product inventory is greater than 30 */        
        if( variant.availableToSell > 30 && variant.inventory_management === 'shopify' ) {
          if(currentProductTemplate == 'limited-quantity-pdp' || currentProductTemplate == 'bespoke-flash-product' || currentProductTemplate == 'bespok-flash-product-meta' || currentProductTemplate == 'bespoke-duchess-products' || currentProductTemplate == 'sold-out-er-build-your-ow' || currentProductTemplate == 'sold-out-er-customize'){
            variant.customLeadTime = 'Only ' + variant.availableToSell + ' left in stock!'
          } else {
            variant.customLeadTime = "In Stock"
          }
          cb(null, { showPopup: false, isVariantLeadMessage: false, dropdownMessage: "In Stock", ...variant })
        }
        /* Inventory lower than or equal to 30 and remaining with only 1 quantity */            
        else if( variant.availableToSell <= 30 && variant.availableToSell > 0 && variant.inventory_management === 'shopify') {
          if((currentProductTemplate == 'limited-quantity-pdp' || currentProductTemplate == 'bespoke-flash-product' || currentProductTemplate == 'bespok-flash-product-meta' || currentProductTemplate == 'bespoke-duchess-products' || currentProductTemplate == 'sold-out-er-build-your-ow' || currentProductTemplate == 'sold-out-er-customize') ){
            variant.customLeadTime = 'Only ' + variant.availableToSell + ' left in stock!'
          } else {
            variant.customLeadTime = `Only a few left!`
          }
          dropdownMessage = `In Stock`
          cb(null, { showPopup: false, isVariantLeadMessage: false, dropdownMessage, ...variant })
        }
        else if (variant.availableToSell <= 0) {
          if (getPreOrderVariantData && getPreOrderVariantData.length) {
            var matchedVariant = null;
            /* Grabbing quantity of variant to sell for Pre order */
            $.each(getPreOrderVariantData, function (index, item) {
              if (item.variant === variant.id) {
                matchedVariant = item;
                return false;
              }
            });
          }
          if (currentProductJson.tags.filter(s => s.includes('pre-order-product')) && variant.inventory_policy == "continue" &&
            matchedVariant !== null && matchedVariant !== undefined && variant.inventory_quantity <= -(matchedVariant.quantity)) {
            variant.customLeadTime = "Sold Out"
            cb(null, { showPopup: true, isVariantLeadMessage: true, dropdownMessage: "Sold Out", ...variant })
          }
          else {
            if (variant.inventory_policy == "continue") {
              /*** * If showPopUpAlso flag is enable then show message * ***/
              var inStockVariantFromTag = currentProductJson.tags.filter(s => s.includes('show-custom-lead-time-text- '));
              var isMatch = false;
              if(inStockVariantFromTag.length > 0){
                var tag = inStockVariantFromTag[0]; // Get the first (and only) tag
                var parts = tag.split('-').pop().trim(); // Get the last part after '-'
                var variantsOptionName = parts.split('|').map(num => num.trim()).join(',');
                isMatch = variantsOptionName.includes(variant.id.toString());
              }
              if (variant.availableToSell <= 0 && variant.customLeadTime) {
                // Cannot add to cart custom popup
                if(currentProductJson.tags.includes("show-custom-lead-time-text") || isMatch === true){
                  cb(null, { showPopup: true, isVariantLeadMessage: true, dropdownMessage: "In Stock", ...variant })
                } else {
                  cb(null, { showPopup: true, isVariantLeadMessage: true, dropdownMessage: "Made to Order", ...variant })
                }
              } else {
                if(currentProductJson.tags.includes("show-custom-lead-time-text") || isMatch === true){
                  cb(null, { showPopup: false, isVariantLeadMessage: true, dropdownMessage: "In Stock", ...variant })
                } else {
                  cb(null, { showPopup: false, isVariantLeadMessage: true, dropdownMessage: "Made to Order", ...variant })
                }
              }
            }
            else {
              // Cannot add to cart custom popup
              dropdownMessage = variant.customLeadTime = "Sold Out"
              cb(null, { showPopup: false, isVariantLeadMessage: false, dropdownMessage, ...variant })
            }
          }
        }
        else {
          cb(null, { showPopup: false, isVariantLeadMessage: false, dropdownMessage, ...variant })
        }
      }
    }
    else {
      cb(null, { showPopup: false, isVariantLeadMessage: false, dropdownMessage: "", ...variant })
    }
  }
  else {
    cb("variant is empty", null)
  }
}

/* Integrating Leadtime on PDP */
var grabEngagementRingsLeadTime = "";
function updateMessageAndAppendProperty(msg, variant) {
  originalLeadTimeMsg = msg;
  var leadTimeEngFromUi = originalLeadTimeMsg.replace(/\s+/g, "");
  var engravableTag = currentProductJson.tags.filter(s => s.includes('Engravable'));
  var customSizeBespokeFlashProducts = currentProductJson ? currentProductJson.tags.filter(s => s.includes('show-bespoke-flash-product')) : [];
  var customSizeBespokeFlashProductsSoldOut = currentProductJson ? currentProductJson.tags.filter(s => s.includes('is-bespoke-sold-out')) : [];
  var isOMSLeadTimeMadeToOrder = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-made-to-order')) : [];
  var isOMSLeadTimeInStock = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-in-stock')) : [];
  if (engravableTag.includes('Engravable')) {
    var engraveMsg = "Please add an additional 2-3 weeks for engraving.";
    if (currentProductTemplate == 'bespoke-flash-product' || currentProductTemplate == 'bespok-flash-product-meta' || currentProductTemplate == 'bespoke-duchess-products' || currentProductTemplate == 'sold-out-er-build-your-ow' || currentProductTemplate == 'sold-out-er-customize' || $('#engravablesInputsWrapper').is(":checked") === true) {
      if (leadTimeEngFromUi.indexOf("instock") !== -1 || leadTimeEngFromUi.indexOf("InStock") !== -1 ||
        leadTimeEngFromUi.indexOf("pieceleft!") !== -1 || leadTimeEngFromUi.indexOf("piecesleft!") !== -1 ||
        leadTimeEngFromUi.indexOf("Onlyafewleft!") !== -1) {
        $(".stock-level-message").text("In Stock. Please add an additional 2-3 weeks for engraving.");
        $('.inv-label--out-stock').addClass('hide')
        $('.inv-label--in-stock').removeClass('hide')
      } else {
        $(".stock-level-message").text(msg + " Please add an additional 2-3 weeks for engraving.");
        $('.inv-label--out-stock').removeClass('hide')
        $('.inv-label--in-stock').addClass('hide')
      }
    } else if ($('#engravablesInputsWrapper').is(":checked") === false) {
      if (msg === " "){
        $('.inv-label--out-stock').addClass('hide')
        $('.inv-label--in-stock').addClass('hide')
      } else {
        if (msg.indexOf("Only a few left!") !== -1 || msg.indexOf("In Stock") !== -1){
          $('.inv-label--out-stock').addClass('hide')
          $('.inv-label--in-stock').removeClass('hide')
        } 
        if (msg.indexOf("Only a few left!") === -1 && msg.indexOf("In Stock") === -1){
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
        } 
        if (msg.indexOf("Sold Out") !== -1){
          $('.inv-label--out-stock').addClass('hide')
          $('.inv-label--in-stock').addClass('hide')
        }
      }
      jQuery(".customStockLevelMessage .stock-level-message").text(msg)
      jQuery("#stockLevelWarningPopupMessage").text(msg)
    }
    if (jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).length > 0) {
      if (engravableChecked === true) {
        if (leadTimeEngFromUi.indexOf("instock") !== -1 || leadTimeEngFromUi.indexOf("InStock") !== -1 ||
          leadTimeEngFromUi.indexOf("pieceleft!") !== -1 || leadTimeEngFromUi.indexOf("piecesleft!") !== -1 ||
          leadTimeEngFromUi.indexOf("Onlyafewleft!") !== -1) {
          jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", "In Stock. Please add an additional 2-3 weeks for engraving.")
        } else {
          jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", msg + " " + engraveMsg)
        }
      } else {
        jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", msg)
      }
    } else {
      if (engravableChecked === true) {
        if (leadTimeEngFromUi.indexOf("instock") !== -1 || leadTimeEngFromUi.indexOf("InStock") !== -1 ||
          leadTimeEngFromUi.indexOf("pieceleft!") !== -1 || leadTimeEngFromUi.indexOf("piecesleft!") !== -1 ||
          leadTimeEngFromUi.indexOf("Onlyafewleft!") !== -1) {
          jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value='In Stock. Please add an additional 2-3 weeks for engraving.' />`)
        } else {
          jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value='${engraveMsg}' />`)
        }
      } else {
        jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value='${msg}' />`)
      }
    }
  } else {
    $("input").prop('disabled', false);
    if(customSizeBespokeFlashProducts && customSizeBespokeFlashProducts.length === 0){
      if (msg && msg.length > 0) {
        if (currentProductTemplate == 'bespoke-flash-product' || currentProductTemplate == 'bespok-flash-product-meta' || currentProductTemplate == 'sold-out-er-build-your-ow' || currentProductTemplate == 'sold-out-er-customize') {
          jQuery(".customStockLevelMessage .stock-level-message").text(msg)
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
        } else {
          if ((msg.indexOf("Only a few left!") !== -1 || msg.indexOf("In Stock") !== -1) && grabDynamicShippingDate && grabDynamicShippingDate !== '') {
            $('.estimated-time-arrival').text(grabDynamicShippingDate)
          } else {
            $('.estimated-time-arrival').text('')
          }
          jQuery(".customStockLevelMessage .stock-level-message").text(msg)
          jQuery("#stockLevelWarningPopupMessage").text(msg)
          if (msg === " "){
            $('.inv-label--out-stock').addClass('hide')
            $('.inv-label--in-stock').addClass('hide')
          } else {
            if (msg.indexOf("Only a few left!") !== -1 || msg.indexOf("In Stock") !== -1){
              $('.inv-label--out-stock').addClass('hide')
              $('.inv-label--in-stock').removeClass('hide')
              $('.stock-status--wrapper').removeClass('add-spacing-lead-time')
            } 
            if (msg.indexOf("Only a few left!") === -1 && msg.indexOf("In Stock") === -1){
              $('.inv-label--out-stock').removeClass('hide')
              $('.inv-label--in-stock').addClass('hide')
              $('.stock-status--wrapper').addClass('add-spacing-lead-time')
            } 
            if (msg.indexOf("Sold Out") !== -1){
              $('.inv-label--out-stock').addClass('hide')
              $('.inv-label--in-stock').addClass('hide')
            }
          }
        }
        var ifLeadTimeFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).length
        if (ifLeadTimeFieldIsPresent > 0) {
          jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", msg)
        } else {
          jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value='${msg}' />`)
        }
      } else {
        $('.inv-label--out-stock').addClass('hide')
        $('.inv-label--in-stock').addClass('hide')
        jQuery(".customStockLevelMessage .stock-level-message").text(msg)
      }
    }
    var inStockVariantFromTag = currentProductJson.tags.filter(s => s.includes('show-custom-lead-time-text- '));
    var isMatch = false;
    if(inStockVariantFromTag.length > 0){
      var tag = inStockVariantFromTag[0]; // Get the first (and only) tag
      var parts = tag.split('-').pop().trim(); // Get the last part after '-'
      var variantsOptionName = parts.split('|').map(num => num.trim()).join(',');
      isMatch = variantsOptionName.includes(variant.id.toString());
    }
    if((isOMSLeadTimeMadeToOrder.length || isOMSLeadTimeInStock.length) && msg?.length > 0){
      if(msg.trim() === "") {
        msg = "Estimated production time is 2 weeks.";
      }
      grabEngagementRingsLeadTime = msg;
      if (isOMSLeadTimeMadeToOrder.length){
        $(".stock-level-message").html(msg)
        $('.inv-label--in-stock').addClass('hide')
        $('.inv-label--out-stock').removeClass('hide')
  
        var ifLeadTimeFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).length
        if (ifLeadTimeFieldIsPresent > 0) {
          jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", msg)
        } else {
          jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value='${msg}' />`)
        }
      }
    }
    if(currentProductJson.tags.includes("show-custom-lead-time-text") || isMatch === true){
      $('.inv-label--in-stock').removeClass('hide');
      $('.inv-label--out-stock').addClass('hide');
      $(".stock-level-message").html("In Stock");
      $('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", "In Stock")
    }
  }
}

function showFinalSaleMessage(finalSaleMessageFlag) {
  // This span should always present in button HTML
  if (jQuery('form[action="/cart/add"]').find(".jsAddtocartFinalSale").length == 0) {
    jQuery('.ProductForm__AddToCart').append(`<span class="jsAddtocartFinalSale addtocart-final-sale"></span>`)
  }
  // Final sale message flag
  if (finalSaleMessageFlag && finalSaleMessageFlag == true) {
    var msg = "(Final Sale!)"
    var checkButtonText = $('.ProductForm__AddToCart').text().toLowerCase();
    if (checkButtonText.indexOf('sold out') !== 0) {
      if($("#engravablesInputsWrapper").length) {
        if($("#engravablesInputsWrapper").prop('checked') === true){
          $('.ProductForm__AddToCart').find('.jsAddtocartFinalSale').text(msg);
        } else {
          $('.ProductForm__AddToCart').find('.jsAddtocartFinalSale').text('');
          if (jQuery('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).length > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).attr("value", '')
          } else {
            jQuery('.ProductForm__AddToCart').before(`<input type="hidden" name="properties[Final_Sale]" value=''/>`)
          }
        }
      } else {
        if(!$('.custom-teaser-cta').length) {
          $('.ProductForm__AddToCart').find('.jsAddtocartFinalSale').text(msg);
        }
      }
    }
    var isFinalSaleElementPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).length
    if(!$("#engravablesInputsWrapper").length){
      if (isFinalSaleElementPresent > 0) {
        jQuery('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).attr("value", msg)
      } else {
        jQuery('.ProductForm__AddToCart').before(`<input type="hidden" name="properties[Final_Sale]" value='${msg}'/>`)
      }
    }
  }
  else {
    jQuery('.ProductForm__AddToCart').find('.jsAddtocartFinalSale').text('')
    if (engravableMatches[0] !== 'Engravable') {
      jQuery('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).remove()
    }
  }
}

var currentVariantResponse = '';
async function executeStockLevelMessages(variant, showPopUpAlso = false, cb) {
  try {
    updateMessageAndAppendProperty(" ", variant)
    showFinalSaleMessage(false)
    var message = "";
    if (currentProductJson.tags.includes("lead-time-bundle") && variant.inventory_quantity > 30 && variant.inventory_management === 'shopify'){
      updateMessageAndAppendProperty("In Stock", variant)
    } else if (currentProductJson.tags.includes("lead-time-bundle") && variant.inventory_quantity <= 30 && variant.inventory_quantity > 0 && variant.inventory_management === 'shopify'){
      updateMessageAndAppendProperty("Only a few left!", variant)
    } else if (currentProductJson.tags.includes("lead-time-bundle") && variant.inventory_quantity <= 0 && variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify'){
      updateMessageAndAppendProperty("Sold Out", variant)
    } else if ((currentProductJson.tags.includes("lead-time-bundle") && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue' && variant.inventory_management === 'shopify')){
      fetch(`${portalApiUrl}/mongo/leadtime?shopifyProductId=${currentProductJson.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(function (getResponse) {
        currentVariantResponse = getResponse;
      })
      .then(async function (vart) {
        vart = currentVariantResponse.data.find(item => parseInt(item.id) === parseInt(variant.id));
        updateMessageAndAppendProperty(vart.customLeadTime, vart)
      })
      .catch((e) => {
        console.log(e, "catchhh")
      })
    } else if (currentProductJson && currentVariantResponse === ''){
      fetch(`${portalApiUrl}/mongo/leadtime?shopifyProductId=${currentProductJson.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(function (getResponse) {
        currentVariantResponse = getResponse;
      })
      .then(async function (vart) {
        vart = currentVariantResponse.data.find(item => parseInt(item.id) === parseInt(variant.id));
        bespokeProductWarningPopup(variant)
        var ifPropertyFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[_giftwrap]"]`).length;
        if (getVariantMetafieldValue(variant.id, "_giftwrap") && getVariantMetafieldValue(variant.id, "_giftwrap") == true) {
          if (ifPropertyFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[_giftwrap]"]`).attr("value", "true");
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[_giftwrap]" value='true' />`);
          }
        } else {
          if (ifPropertyFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[_giftwrap]"]`).remove();
          }
        }
        variantStockLogic(vart, function (error, data) {
          if (currentProductJson.tags.includes("Engravable")) {
            if (engravableChecked === true) {
              jQuery("input[name='properties[_excludeFromNarvar]']").val("yes")
            } else {
              jQuery("input[name='properties[_excludeFromNarvar]']").val("no")
            }
          } else {
            if (vart && vart.exclude_from_narvar && vart.exclude_from_narvar == true) {
              jQuery("input[name='properties[_excludeFromNarvar]']").val("yes")
            } else {
              jQuery("input[name='properties[_excludeFromNarvar]']").val("no")
            }
          }

          var textmsg = data.customLeadTime.toLowerCase();
          if ((textmsg.indexOf("week") != -1) || (textmsg.indexOf("days") != -1) || (textmsg.indexOf("estimated") != -1)) {
            $('.custom-stock-level-message').addClass('clock-enabled')
          }

          showNotifyMeMessage(data)
          updateMessageAndAppendProperty(data.customLeadTime, data)
          showFinalSaleMessage(data.sale_message)
          cb(error, data)
        })
      })
      .then(function () {
        updateDropdownInventoryOptions()
      }).catch((e) => {
        console.log(e, "catchhh")
      })
    }
    else if (currentProductJson && currentVariantResponse !== '') {
      var vart = variant
      for (var i = 0; i < currentVariantResponse.data.length; i++) {
        if (parseInt(currentVariantResponse.data[i].id) === parseInt(variant.id)) {
          vart = currentVariantResponse.data[i];
        }
      }
      variantStockLogic(vart, function (error, data) {
        if (currentProductJson.tags.includes("Engravable")) {
          if (engravableChecked === true) {
            jQuery("input[name='properties[_excludeFromNarvar]']").val("yes")
          } else {
            jQuery("input[name='properties[_excludeFromNarvar]']").val("no")
          }
        } else {
          if (vart && vart.exclude_from_narvar && vart.exclude_from_narvar == true) {
            jQuery("input[name='properties[_excludeFromNarvar]']").val("yes")
          } else {
            jQuery("input[name='properties[_excludeFromNarvar]']").val("no")
          }
        }
        showNotifyMeMessage(data)
        updateMessageAndAppendProperty(data.customLeadTime, data)
        showFinalSaleMessage(data.sale_message)
        updateDropdownInventoryOptions()
        cb(error, data)
      })
    }
    else {
      cb(null, { showPopup: false, data: variant, message })
    }
  } catch (error) {
    console.log('An error occurred:', error);
  }
}

/*** Update dropdown options ***/
function updateDropdownInventoryOptions() {
  var hideSoldOutSizes = currentProductJson ? currentProductJson.tags.filter(s => s.includes('hide-sold-out-sizes')) : [];
  var hideUnhideValues = currentProductJson ? currentProductJson.tags.filter(s => s.includes('custom-diamond-coverage')) : [];
  $("#customization").prop('disabled', false);
  if (currentProductTemplate && currentProductTemplate !== 'vow.engagement.rings') {
    var data = JSON.parse(jQuery("#pageActionProduct").text());
    var grabDropDownName = currentProductJson.tags.filter(s => s.includes('show-bespoke-flash-product'));
    for (var i = 0; i < data.length; i++) {
      if (data[i] !== "Width") {
        if (!grabDropDownName && grabDropDownName.length === 0) jQuery(".Popover__ValueList .popover-value-stock-label").text("")
      } else {
        jQuery(".Popover__ValueList .popover-value-stock-label").text("") //Showing Loading...
      }
    }
    var associatedVariants = []
    var currentDropdownInUi = currentProductJson.options.length
    var notLoadingShow = []
    var dropdownOptionSelect = []
    $(".ProductForm").find("ul.HorizontalList--spacingTight").each(function (index) {
      if (jQuery(this).attr("aria-controls").indexOf('template-color-dropdown-options') !== -1 ||
        jQuery(this).attr("aria-controls").indexOf('template-stone-options') !== -1) {
        notLoadingShow.push(jQuery(this).attr("aria-controls"))
      } else if(jQuery(this).attr("aria-controls").indexOf('custom-size-dropdown-options') === -1 && jQuery(this).attr("aria-controls").indexOf('carat-weight-dropdown-options') === -1) {
        dropdownOptionSelect.push({
          btnId: jQuery(this),
          popOver: jQuery(this).attr("aria-controls")
        })
      }
    })
    jQuery(".ProductForm").find("button.ProductForm__Item").each(function (index) {
      if (jQuery(this).attr("aria-controls").indexOf('template-color-dropdown-options') !== -1 || 
        $(this).is(".custom_size_meta_drop_down, .custom_size_meta_drop_down_2, .custom_size_meta_drop_down_3, .carat_weight_drop_down") ||
        jQuery(this).attr("aria-controls").indexOf('template-stone-options') !== -1 || jQuery(this).attr("aria-controls").indexOf("diamond-coverage-dropdown-options") !== -1) {
        notLoadingShow.push(jQuery(this).attr("aria-controls"))
      } else {
        dropdownOptionSelect.push({
          btnId: jQuery(this),
          popOver: jQuery(this).attr("aria-controls")
        })
      }
    })
    var dropdownOneValue = null, dropdownTwoValue = null, dropdownThreeValue = null, dropdownOneTargetId = null, dropdownTwoTargetId = null, dropdownThreeTargetId = null
    for (var j = 0; j < dropdownOptionSelect.length; j++) {
      var btnId = dropdownOptionSelect[j].btnId

      switch (j) {
        case 0:
          dropdownOneTargetId = dropdownOptionSelect[j].popOver
          if (data.includes("Metal")) {
            dropdownOneValue = jQuery(btnId).parent().find(".ProductForm__SelectedValue").text()
          } else {
            dropdownOneValue = jQuery(btnId).find(".ProductForm__SelectedValue").text()
          }
          break
        case 1:
          dropdownTwoTargetId = dropdownOptionSelect[j].popOver
          if (data.includes("Color")) {
            dropdownTwoValue = jQuery(btnId).parent().find(".ProductForm__SelectedValue").text()
          } else {
            dropdownTwoValue = jQuery(btnId).find(".ProductForm__SelectedValue").text()
          }
          break
        case 2:
          dropdownThreeTargetId = dropdownOptionSelect[j].popOver
          dropdownThreeValue = jQuery(btnId).find(".ProductForm__SelectedValue").text()
          break
      }
    }
    if (notLoadingShow.length) {
      for (var i = 0; i < notLoadingShow.length; i++) {
        var id = notLoadingShow[i]
        jQuery(`#${id}`).find(".popover-value-stock-label").text('Custom Mode')
      }
    }

    var allVariantsWithStockMessage = []
    currentVariantResponse?.data?.map(function (v, j) {
      allVariantsWithStockMessage.push(
        // Getting current product with our stock level message
        new Promise(function (resolve, reject) {
          variantStockLogic(v, function (err, vari) {
            if (!err) {
              resolve(vari)
            }
          })
        })
      )
    })

    Promise.all(allVariantsWithStockMessage)
      .then(function (allVariants) {
        var dropdownOneVOptions = []
        var dropdownTwoVOptions = []
        var dropdownThreeVOptions = []

        allVariants.map(function (variant, j) {
          if (currentDropdownInUi == 1) {
            dropdownOneVOptions.push(variant)
          }
          if (currentDropdownInUi == 2) {
            if (variant.option2 == dropdownTwoValue) {
              dropdownOneVOptions.push({ dropdownMessage: "", option1: variant.option1, option2: variant.option2, option3: variant.option3 })
            }
            if (variant.option1 == dropdownOneValue) {
              dropdownTwoVOptions.push(variant)
            }
          }
          if (currentDropdownInUi == 3) {
            if (variant.option2 == dropdownTwoValue && variant.option3 == dropdownThreeValue) {
              dropdownOneVOptions.push({ dropdownMessage: "", option1: variant.option1, option2: variant.option2, option3: variant.option3 })
            }
            if (variant.option1 == dropdownOneValue && variant.option3 == dropdownThreeValue) {
              dropdownTwoVOptions.push({ dropdownMessage: "", option1: variant.option1, option2: variant.option2, option3: variant.option3 })
            }
            if (variant.option2 == dropdownTwoValue && variant.option1 == dropdownOneValue) {
              dropdownThreeVOptions.push(variant)
            }
          }
        })
        if (dropdownOneTargetId && dropdownOneVOptions && dropdownOneVOptions.length >= 1) {
          dropdownOneVOptions.map(function (v, i) {
            var message = v.dropdownMessage
            if(hideSoldOutSizes !== [] && hideSoldOutSizes.length > 0 && v.inventory_policy === "deny" && v.availableToSell <= 0){
              jQuery(`#${dropdownOneTargetId} .Popover__ValueList`).find(`button[data-value="${v.option1}"]`).addClass("hide");
            } else {
              jQuery(`#${dropdownOneTargetId} .Popover__ValueList`).find(`button[data-value="${v.option1}"]`).removeClass("hide");
            }
            // If double quotes is not present in string then check by single quote
            if (v.option1.indexOf("I don't know my size") !== -1 || v.option1.indexOf("I don't know my ring size") !== -1) {
              message = ""
            }
            if (v.option1.indexOf('"') === -1) {
              jQuery(`#${dropdownOneTargetId} .Popover__ValueList`).find(`button[data-value="${v.option1}"]`).find(".popover-value-stock-label").text(message);
            } else {
              jQuery(`#${dropdownOneTargetId} .Popover__ValueList`).find(`button[data-value='${v.option1}']`).find(".popover-value-stock-label").text(message);
            }
          })
        }
        if (dropdownTwoTargetId && dropdownTwoVOptions && dropdownTwoVOptions.length >= 1) {
          dropdownTwoVOptions.map(function (v, i) {
            var message = v.dropdownMessage
            if(hideSoldOutSizes !== [] && hideSoldOutSizes.length > 0 && v.inventory_policy === "deny" && v.availableToSell <= 0){
              jQuery(`#${dropdownTwoTargetId} .Popover__ValueList`).find(`button[data-value="${v.option2}"]`).addClass("hide");
            } else {
              if (v.option2.indexOf('"') !== -1) {
                jQuery(`#${dropdownTwoTargetId} .Popover__ValueList`).find(`button[data-value='${v.option2}']`).removeClass("hide");
              } else {
                if(hideUnhideValues.length === 0){
                  jQuery(`#${dropdownTwoTargetId} .Popover__ValueList`).find(`button[data-value="${v.option2}"]`).removeClass("hide");
                }
              }
            }
            // If double quotes is not present in string then check by single quote
            if (v.option2.indexOf("I don't know my size") !== -1 || v.option2.indexOf("I don't know my ring size") !== -1) {
              message = ""
            }
            if (v.option2.indexOf('"') === -1) {
              jQuery(`#${dropdownTwoTargetId} .Popover__ValueList`).find(`button[data-value="${v.option2}"]`).find(".popover-value-stock-label").text(message);
            } else {
              jQuery(`#${dropdownTwoTargetId} .Popover__ValueList`).find(`button[data-value='${v.option2}']`).find(".popover-value-stock-label").text(message);
            }
          })
        }
        if (dropdownThreeTargetId && dropdownThreeVOptions && dropdownThreeVOptions.length >= 1) {
          dropdownThreeVOptions.map(function (v, i) {
            var message = v.dropdownMessage
            // If double quotes is not present in string then check by single quote
            if(hideSoldOutSizes !== [] && hideSoldOutSizes.length > 0 && v.inventory_policy === "deny" && v.availableToSell <= 0){
              jQuery(`#${dropdownThreeTargetId} .Popover__ValueList`).find(`button[data-value='${v.option3}']`).addClass("hide");
            } else {
              jQuery(`#${dropdownThreeTargetId} .Popover__ValueList`).find(`button[data-value='${v.option3}']`).removeClass("hide");
            }
            if (v.option3.indexOf("I don't know my size") !== -1 || v.option3.indexOf("I don't know my ring size") !== -1) {
              message = ""
            }
            if (v.option3.indexOf('"') === -1) {
              if ($(".ProductForm__AddToCart").text() !== 'Unavailable') {
                jQuery(`#${dropdownThreeTargetId} .Popover__ValueList`).find(`button[data-value="${v.option3}"]`).find(".popover-value-stock-label").text(message);
              }
            } else {
              if ($(".ProductForm__AddToCart").text() !== 'Unavailable') {
                jQuery(`#${dropdownThreeTargetId} .Popover__ValueList`).find(`button[data-value='${v.option3}']`).find(".popover-value-stock-label").text(message);
              }
            }
          })
        }
     })
  }
}

function countZero(){
  setTimeout(function() {
    if($(".Popover__Value.Heading.Link.Link--primary.u-h6.is-selected").hasClass("hide")){
      counting = 0;
      chooseFirstInStockVariant();
    }
  }, 200);
}

var counting = 0;
function chooseFirstInStockVariant(){
  if(counting !== 0) return;
  counting = counting + 1;
  let $buttons = $(".Popover__Value.Heading.Link.Link--primary.u-h6");
  if ($buttons.length > 0) {
    $buttons.each(function () {
      let $this = $(this);
      if ($this.hasClass("is-selected") && $this.hasClass("hide")) {
        $this.removeClass("is-selected");
      }
      if (!$this.hasClass("hide")) {
        $this.get(0).click();
        return false;
      }
    });
  }
}

/************************* Get all diamond products-Cart *************************/
function getDiamondProductFromCart() {
  var vowProductInfo = {}
  var allProducts = document.querySelectorAll("tr.product");
  for (var i = 0; i < allProducts.length; i++) {
    if (allProducts[i].getAttribute("data-product-type") === 'Diamond') {
      vowProductInfo['diamond_productId'] = allProducts[i].getAttribute("data-product-id")
      vowProductInfo['diamond_variantId'] = allProducts[i].getAttribute("data-variant-id")
      vowProductInfo['diamond_retailPrice'] = allProducts[i].querySelectorAll("td.product__price")[0].textContent.trim()
      vowProductInfo['diamondTitle'] = allProducts[i].querySelectorAll(".product__description__name")[0].textContent.trim()
    }
  }
  return vowProductInfo;
}

/************************* Checking Diamond Price *************************/
function checkDiamondPriceMatchedorNot(checkoutId) {
  try {
    var diamondProductInfo = getDiamondProductFromCart()
    if (diamondProductInfo && diamondProductInfo.diamond_productId) {
      return fetch(`${portalApiUrl}/verify_diamond_price`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(diamondProductInfo)
      })
        .then(response => response.json())
        .then(function (res) {
          if (res && res.action && res.action == "remove") {
            jQuery("#dynamicModal").find(".cm-modal-title").text("Your Diamond Price has Changed")
            jQuery("#dynamicModal").find(".cm-modal-subtitle").text("The diamond you selected price has changed.")
            jQuery("#dynamicModal").find(".cusCartButton").text("See the Updated price")
            jQuery("#dynamicModal").addClass("open")
          }
        })
    }
  } catch (error) {
    console.log('An error occurred:', error);
  }
}	